import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
import React, { useEffect, useState, useRef, useCallback } from "react";
import SellCarHero from "./SellCarHero";
import { GetSellTradeList } from "@/pages/sell-trade-v2/api/GetSellTradeList";
import MobileHeroLayout from "./MobileHeroLayout";
import DesktopHeroLayout from "./DesktopHeroLayout";
var CarSaleHeroSection = function CarSaleHeroSection(_ref) {
  var _ref$autoPlay = _ref.autoPlay,
    autoPlay = _ref$autoPlay === void 0 ? false : _ref$autoPlay,
    _ref$autoPlayInterval = _ref.autoPlayInterval,
    autoPlayInterval = _ref$autoPlayInterval === void 0 ? 5000 : _ref$autoPlayInterval,
    onBookAppointment = _ref.onBookAppointment,
    data = _ref.data;
  var _useState = useState([]),
    sellTradeItems = _useState[0],
    setSellTradeItems = _useState[1];
  var _useState2 = useState(true),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = useState(null),
    metadata = _useState3[0],
    setMetadata = _useState3[1];
  var _useState4 = useState(new Set()),
    loadedPages = _useState4[0],
    setLoadedPages = _useState4[1];
  var _useState5 = useState(false),
    hasAttemptedFetch = _useState5[0],
    setHasAttemptedFetch = _useState5[1];
  var isFetchingRef = useRef(false);

  // Fetch a specific page
  var fetchPage = useCallback(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(page) {
      var isInitialFetch,
        response,
        _args = arguments,
        _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            isInitialFetch = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
            if (!(isFetchingRef.current || loadedPages.has(page))) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            isFetchingRef.current = true;
            _context.p = 2;
            _context.n = 3;
            return GetSellTradeList(page);
          case 3:
            response = _context.v;
            if (response !== null && response !== void 0 && response.success && Array.isArray(response === null || response === void 0 ? void 0 : response.data)) {
              setSellTradeItems(function (prevItems) {
                // Create a map of existing items by request_id
                var itemsMap = new Map(prevItems.map(function (item) {
                  return [item.request_id || item.id, item];
                }));

                // Add new items
                response.data.forEach(function (item) {
                  itemsMap.set(item.request_id || item.id, item);
                });

                // Convert back to array and sort by request_date (newest first)
                return Array.from(itemsMap.values()).sort(function (a, b) {
                  var dateA = new Date(a.request_date || 0).getTime();
                  var dateB = new Date(b.request_date || 0).getTime();
                  return dateB - dateA;
                });
              });
              setMetadata(response.metaData);
              setLoadedPages(function (prev) {
                return new Set([].concat(_toConsumableArray(prev), [page]));
              });
            }

            // Only update loading state when fetch actually completed (not when skipped)
            if (isInitialFetch) {
              setIsLoading(false);
              setHasAttemptedFetch(true);
            }
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            if (isInitialFetch) {
              setIsLoading(false);
              setHasAttemptedFetch(true);
            }
          case 5:
            _context.p = 5;
            isFetchingRef.current = false;
            return _context.f(5);
          case 6:
            return _context.a(2);
        }
      }, _callee, null, [[2, 4, 5, 6]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [loadedPages]);

  // Initial fetch
  useEffect(function () {
    fetchPage(1, true);
  }, []);

  // Handle carousel slide change - fetch next page if near end
  var handleSlideChange = useCallback(function (currentSlide) {
    if (!metadata) return;
    var totalItems = sellTradeItems.length;
    var threshold = 3; // Fetch next page when user is 3 items away from end

    // Check if we're near the end and if there are more pages
    if (currentSlide >= totalItems - threshold && metadata.current_page < metadata.total_pages) {
      var nextPage = metadata.current_page + 1;
      if (!loadedPages.has(nextPage)) {
        fetchPage(nextPage);
      }
    }
  }, [metadata, sellTradeItems.length, loadedPages]);

  // Refetch data - used after cancellation
  var handleRefetch = useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    var response, _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          setSellTradeItems([]);
          setLoadedPages(new Set());
          setMetadata(null);
          setIsLoading(true);
          isFetchingRef.current = false;
          _context2.p = 1;
          _context2.n = 2;
          return GetSellTradeList(1);
        case 2:
          response = _context2.v;
          if (response !== null && response !== void 0 && response.success && Array.isArray(response === null || response === void 0 ? void 0 : response.data)) {
            setSellTradeItems(response.data.sort(function (a, b) {
              var dateA = new Date(a.request_date || 0).getTime();
              var dateB = new Date(b.request_date || 0).getTime();
              return dateB - dateA;
            }));
            setMetadata(response.metaData);
            setLoadedPages(new Set([1]));
          }
          _context2.n = 4;
          break;
        case 3:
          _context2.p = 3;
          _t2 = _context2.v;
        case 4:
          _context2.p = 4;
          setIsLoading(false);
          setHasAttemptedFetch(true);
          isFetchingRef.current = false;
          return _context2.f(4);
        case 5:
          return _context2.a(2);
      }
    }, _callee2, null, [[1, 3, 4, 5]]);
  })), []);

  // Show SellCarHero only when:
  // 1. Not currently loading (fetch has completed)
  // 2. Fetch has been attempted
  // 3. No items exist
  if (!isLoading && hasAttemptedFetch && sellTradeItems.length === 0) {
    return /*#__PURE__*/React.createElement(SellCarHero, {
      data: data
    });
  }
  var layoutProps = {
    data: data,
    isLoading: isLoading,
    sellTradeItems: sellTradeItems,
    autoPlay: autoPlay,
    autoPlayInterval: autoPlayInterval,
    onBookAppointment: onBookAppointment,
    onSlideChange: handleSlideChange,
    onRefetch: handleRefetch
  };
  return /*#__PURE__*/React.createElement("div", {
    id: "car-sale-hero-section",
    className: "relative w-full"
  }, /*#__PURE__*/React.createElement(MobileHeroLayout, layoutProps), /*#__PURE__*/React.createElement(DesktopHeroLayout, layoutProps));
};
export default CarSaleHeroSection;